export enum ContactInformationActionsTypes {
  GET = "@@CONTACT_INFORMATIONS get",
  GET_STATUS = "@@CONTACT_INFORMATIONS get status",
  PATCH = "@@CONTACT_INFORMATIONS patch ",
  PATCH_STATUS = "@@CONTACT_INFORMATIONS patch status"
}
